import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './loai-quy-hoach.reducer';

export const LoaiQuyHoachDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const loaiQuyHoachEntity = useAppSelector(state => state.loaiQuyHoach.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="loaiQuyHoachDetailsHeading">
          <Translate contentKey="xtdtApp.loaiQuyHoach.detail.title">LoaiQuyHoach</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{loaiQuyHoachEntity.id}</dd>
          <dt>
            <span id="ten">
              <Translate contentKey="xtdtApp.loaiQuyHoach.ten">Ten</Translate>
            </span>
          </dt>
          <dd>{loaiQuyHoachEntity.ten}</dd>
        </dl>
        <Button tag={Link} to="/loai-quy-hoach" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/loai-quy-hoach/${loaiQuyHoachEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LoaiQuyHoachDetail;
